import { isUser } from '@tunein/web-common';

export const FETCH_MORE_ITEMS = 'FETCH_MORE_ITEMS';

export function fetchMoreItems(requestParams) {
  const { selectedContentId, containerNavigation, containerIndex, offset, limit } = requestParams;
  const { destinationInfo } = containerNavigation;
  const { id: guideId, requestType } = destinationInfo;
  const params = {
    ...destinationInfo.attributes,
    // needed due to inconsistencies with how API returns itemToken property
    itemToken: containerNavigation.itemToken || containerNavigation.context.itemToken,
    offset,
    limit,
  };
  const requestOrigin = isUser(guideId) || guideId === 'me' ? 'Favorites' : requestType;

  return {
    type: FETCH_MORE_ITEMS,
    api: {
      endpoint: ['ui', 'getMoreItems'],
      args: [{ guideId, requestOrigin, params }],
      isWACBeta: true,
    },
    meta: {
      contentId: selectedContentId,
      containerIndex,
    },
  };
}
